/* unplugin-vue-components disabled */import script from "./TopTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopTitle.vue?vue&type=script&lang=ts&setup=true"

import "./TopTitle.vue?vue&type=style&index=0&id=372a2f3c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372a2f3c"]])

export default __exports__